(function () {
    "use strict";
    angular
        .module("common.services")
        .factory("learningPathVersionResource", ["$resource", learningPathVersionResource]);
    function learningPathVersionResource($resource) {
        return $resource("/api/learningPathVersions/:id/:action", { id: "@id" }, {
            publish: {
                method: "POST",
                params: { action: "publish" }
            },
            unpublish: {
                method: "POST",
                params: { action: "unpublish" }
            },
            saveAccessExpires: {
                method: "POST",
                params: { action: "saveAccessExpires" }
            },
            saveCECredits: {
                method: "POST",
                params: { action: "ceCredits" }
            },
            saveExpiresDuration: {
                method: "POST",
                params: { action: "expiresDuration" }
            },
            saveHasCertificate: {
                method: "POST",
                params: { action: "hasCertificate" }
            },
            saveIsInformationEnabled: {
                method: "POST",
                params: { action: "informationEnabled" }
            },
            saveIsReassignEnabled: {
                method: "POST",
                params: { action: "isReassignEnabled" }
            },
            setActiveVersion: {
                method: "POST",
                params: { action: "activeVersion" }
            }
        });
    }
}());
